/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForThreatsOci extends models.GovernanceConfigurationBaseForThreats {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForThreatsOci");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForThreatsOci.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForThreatsOci>): GovernanceConfigurationForThreatsOci {
        let obj = Object.assign(new GovernanceConfigurationForThreatsOci(), model);
        GovernanceConfigurationForThreatsOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForThreatsOci>): GovernanceConfigurationForThreatsOci {
        if (!model) return null;
        return GovernanceConfigurationForThreatsOci.newInstance(<GovernanceConfigurationForThreatsOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForThreatsOci) {
        if (!obj) return;

        models.GovernanceConfigurationForThreatsOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForThreatsOci): boolean {
        if (models.GovernanceConfigurationBaseForThreats.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForThreatsOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether OCI CloudGuard enabled or not
     */
    cloud_guard_enabled: boolean;

}
